import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import MessageTemplate from './template/MessageTemplate';
import LoadingTemplate from './template/LoadingTemplate';
import { useAuth } from './AuthProvider';
// import '../app/globals.css'

const TemplateContext = createContext();

export function useTemplate() {
  return useContext(TemplateContext);
}

function TemplateProvider({children}) {
  const suggestRef = useRef();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [headerText, setHeaderText] = useState(null);
  const [reloadKey, setReloadKey] = useState(null);
  const {setUserSl,logout } = useAuth();


  const value = useMemo(
    () => ({
      suggestRef,
      message,
      setMessage,
      confirm,
      setConfirm,
      loading,
      setLoading,
      reloadKey,
      setReloadKey,
      headerText,
      setHeaderText
    }),
    [confirm, message, loading, reloadKey,headerText],
  );
  useEffect(() => {
    if (message?.text === 'User Not Found') {
      setUserSl('')
      localStorage.setItem('userId', '');
    }
  }, [message, setUserSl, logout]);
  return (
    <TemplateContext.Provider value={value}>
      {children}

      <MessageTemplate message={message} setMessage={setMessage} />
      <LoadingTemplate loading={loading} />
    </TemplateContext.Provider>
  );
}

export default TemplateProvider;
